<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="申请单总结明细">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="isEdit"
            :showSaveBtn="isEdit"
            :disabled="!isEdit"
            @save="save(1)"
            @submit="submit(2)"
            @cancelForm="cancel"
            @input="handInput"
          />
        </div>
      </folded-panel>
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import { addForm, idQuery, updatedForm } from "@/api/bill/summary";
import { getDocumentCode } from "@/views/utils";
import initDict from "@/mixin/initDict";
import FoldedPanel from "@/components/FoldedPanel";
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
export default {
  name: "SummaryDetail",
  mixins: [initDict],
  components: { FoldedPanel ,DragDialog,PersonStep},
  data() {
    return {
      id: "",
      form: { frameContent: [], supportContentAssess: [], supportType: [] },
      isEdit: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "申请单",
            key: "applyforId",
            type: "databox",
            placeholder: "请选择申请单",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/skill-support-apply-for",
            tableColumn: [
              {
                property: "name",
                label: "申请单名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { billState: 3 },
            multiple: false,
            disabled: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "databox",
            key: "bsProject",
            label: "项目名称",
            disabled: true,
            placeholder: "请选择项目",
            value: {},
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bizTaskDecomposition/findProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "项目名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
            // rules: {
            //   required: true,
            //   message: "不能为空",
            //   trigger: "change"
            // }
          },
          {
            type: "input",
            key: "projectCode",
            label: "项目编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "技术支持人员",
            key: "skillBacker",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "事业部参与人员",
            key: "joinPersonnel",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: true
          },
          {
            label: "支持方式",
            key: "supportType",
            type: "select",
            disabled: false,
            multiple: true,
            value: [],
            span: 8,
            options: []
          },
          {
            type: "textarea",
            key: "supportSummary",
            label: "支持活动纪要",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 20,
            maxlength: 200
          },
          {
            type: "textarea",
            key: "supportResult",
            label: "支持成果",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 20,
            maxlength: 200
          },
          {
            type: "checkbox",
            key: "supportContentAssess",
            label: "支持内容评估",
            disabled: false,
            value: [],
            placeholder: "请输入备注",
            span: 18,
            border: false,
            maxlength: 200,
            options: []
          },
          {
            type: "number",
            key: "supportTime",
            label: "有效支持时间",
            value: "",
            span: 8
          },
          // {
          //   span: 12
          // },
          {
            type: "checkbox",
            key: "frameContent",
            label: "涉及框架内容",
            disabled: false,
            value: [],
            span: 20,
            border: false,
            options: []
          },
          {
            span: 20,
            type: "radio",
            label: "支持类型",
            value: "0",
            button: false,
            border: false,
            key: "ifAcrossTheGroup",
            options: [
              {
                value: "1",
                label: "跨事业部支持"
              },
              {
                value: "0",
                label: "非跨事业部支持"
              },
              {
                value: "2",
                label: "框架技术支持"
              }
            ]
          }
        ]
      },
      receipTypes: [],
      personStepData: [],
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
    };
  },
  created() {
   this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      idQuery(this.id).then(res => {
        if (!res.data.frameContentList) {
          res.data.frameContentList = [];
        }
        if (!res.data.supportContentAssessList) {
          res.data.supportContentAssessList = [];
        }
        this.form = res.data;
        this.form.applyforId = {
          name: res.data.applyforName,
          id: res.data.applyforId
        };
        this.form.frameContent = res.data.frameContentList;
        this.form.supportContentAssess = res.data.supportContentAssessList;
        this.form.joinPersonnel = res.data.joinPersonnelPerson;
        this.form.skillBacker = {
          name: res.data.skillBackerName,
          id: res.data.skillBacker
        };
        this.form.supportType
          ? (this.form.supportType = this.form.supportType.split(","))
          : (this.form.supportType = []);
        this.form.frameContent.length > 0
          ? this.handInput(this.form, "frameContent")
          : "";
        this.form.supportContentAssess.length > 0
          ? this.handInput(this.form, "supportContentAssess")
          : "";
        this.handInput(this.form, "ifAcrossTheGroup");
      });
    } else {
      this.form.code = getDocumentCode("JSZCZJ");
    }
    this.getDict("frameType").then(res => {
      // 框架类型
      this.formConfig.formItemList[
        this.formConfig.formItemList.findIndex(
          ele => ele.key === "frameContent"
        )
      ].options = res.data;
    });
    this.getDict("supportContent").then(res => {
      // 支持内容
      this.formConfig.formItemList[
        this.formConfig.formItemList.findIndex(
          ele => ele.key === "supportContentAssess"
        )
      ].options = res.data;
    });
    this.getDict("supportWay").then(res => {
      // 支持方式
      this.formConfig.formItemList[
        this.formConfig.formItemList.findIndex(ele => ele.key === "supportType")
      ].options = res.data;
    });
  },
  watch: {},
  methods: {
    /**
     * 表单值改变
     */
    handInput(val, key) {
      const index = this.formConfig.formItemList.findIndex(
        ele => ele.key === "ifAcrossTheGroup"
      );
      const moneyIndex = this.formConfig.formItemList.findIndex(
        ele => ele.key === "costMoney"
      );
      const obj = {
        type: "number",
        key: "costMoney",
        label: "成本确认金额",
        value: "",
        span: 8,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      };

      const remarkdIndex = this.formConfig.formItemList.findIndex(
        ele => ele.key === "supportContentAssess"
      );
      const contendIndex = this.formConfig.formItemList.findIndex(
        ele => ele.key === "supportContentAssessElse"
      );
      const conObj = {
        type: "input",
        key: "supportContentAssessElse",
        label: "其他支持内容",
        value: "",
        span: 18,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      };

      const frameContentIndex = this.formConfig.formItemList.findIndex(
        ele => ele.key === "frameContent"
      );
      const frameContentElseIndex = this.formConfig.formItemList.findIndex(
        ele => ele.key === "frameContentElse"
      );
      const frameContentElseObj = {
        type: "input",
        key: "frameContentElse",
        label: "其他框架内容",
        value: "",
        span: 18,
        rules: {
          required: true,
          message: "不能为空",
          trigger: "blur"
        }
      };
      switch (key) {
        case "ifAcrossTheGroup": // 是否跨事业部
          if (val[key] === "1" && moneyIndex === -1) {
            this.formConfig.formItemList.splice(index + 1, 0, obj);
          } else {
            if (moneyIndex !== -1) {
              this.form.costMoney = "";
              this.formConfig.formItemList.splice(moneyIndex, 1);
            }
          }
          if (val[key] === "2") {
            this.formConfig.formItemList[
              this.formConfig.formItemList.findIndex(
                ele => ele.key === "frameContent"
              )
            ].hidden = true;
            this.formConfig.formItemList.splice(frameContentElseIndex,1)
          } else {
            this.formConfig.formItemList[
              this.formConfig.formItemList.findIndex(
                ele => ele.key === "frameContent"
              )
            ].hidden = false;
            if (frameContentElseIndex === -1) {
              this.formConfig.formItemList.splice(index,0,frameContentElseObj)
            }
          }
          break;
        case "supportContentAssess": // 支持内容评估
          if (val[key].includes("1") && contendIndex === -1) {
            this.formConfig.formItemList.splice(remarkdIndex + 1, 0, conObj);
          } else if (!val[key].includes("1") && contendIndex !== -1) {
            this.form.supportContentAssessElse = "";
            this.formConfig.formItemList.splice(contendIndex, 1);
          }
          break;
        case "frameContent": // 涉及框架内容
          if (val[key].includes("1") && frameContentElseIndex === -1) {
            this.formConfig.formItemList.splice(
              frameContentIndex + 1,
              0,
              frameContentElseObj
            );
          } else if (!val[key].includes("1") && frameContentElseIndex !== -1) {
            this.form.frameContentElse = "";
            this.formConfig.formItemList.splice(frameContentElseIndex, 1);
          }
          break;
        // case "bsProject":
        //   if (val[key]) {
        //     this.form.projectCode = val[key].code
        //   } else {
        //     this.form.projectCode = ""
        //   }
        //   break;
        case "applyforId": // 申请单
          console.log(val[key]);
          if (val[key]) {
            this.form.bsProject = val[key].bsProject;
            this.form.projectCode = val[key].bsProject.code;
            this.form.skillBacker = {
              name: val[key].skillBackerName,
              id: val[key].skillBacker
            };
            this.form.supportContentAssess = val[key].supportContentList;
            this.form.supportContentAssessElse = val[key].supportContentElse;
            this.form.frameContent = val[key].frameTypeList;
            this.form.frameContentElse = val[key].frameTypeElse;
            this.form.ifAcrossTheGroup = val[key].ifAcrossTheGroup;
            this.form.costMoney = val[key].predictMoney;
          } else {
            this.form.bsProject = {};
            this.form.projectCode = "";
            this.form.skillBacker = {};
            this.form.supportContentAssess = [];
            this.form.supportContentAssessElse = "";
            this.form.frameContent = [];
            this.form.frameContentElse = "";
            this.form.ifAcrossTheGroup = "0";
            this.form.costMoney = "";
          }
          this.handInput(this.form, "frameContent");
          this.handInput(this.form, "supportContentAssess");
          this.handInput(this.form, "ifAcrossTheGroup");
          break;
        default:
          break;
      }
    },
      close() {
        this.stepShow = false;
    },
    submitConfirm(val) {
      // this.getFormData(2,val)
       const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
       obj.from = "applicationForm_affirm"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
    // 提交
    submit(status) {
      // this.pull(this.getFormData(status));
       this.loading = false;
        getFlowNode({ from: "applicationForm_affirm", id: this.form.id }).then(res => {
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        });
    },
    // 保存
    save(status) {
      this.pull(this.getFormData(status));
    },
    // 组装表单数据
    getFormData(status) {
      console.log(this.form);
      const obj = { ...this.form };
      obj.billState = status;
      obj.joinPersonnelId = "";
      obj.skillBacker ? (obj.skillBacker = obj.skillBacker.id) : "";
      obj.supportContentAssessList = obj.supportContentAssess;
      obj.supportContentAssess = "";
      obj.frameContentList = obj.frameContent;
      obj.frameContent = "";
      obj.applyforId ? (obj.applyforId = obj.applyforId.id) : "";
      obj.supportType = obj.supportType + "";
      if (this.form.joinPersonnel) {
        this.form.joinPersonnel.forEach(ele => {
          !obj.joinPersonnelId
            ? (obj.joinPersonnelId = ele.id)
            : (obj.joinPersonnelId = obj.joinPersonnelId + "," + ele.id);
        });
        obj.joinPersonnel = obj.joinPersonnelId;
      }
      return obj;
    },
    cancel() {
      this.$router.go(-1);
    },
    back() {
      this.$router.go(-1);
    },
    pull(obj) {
      if (this.id) {
        updatedForm(obj).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      } else {
        addForm(obj).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-icon-back {
  padding-bottom: 10px;
}
</style>
